<template>
  <v-chip dense :color="chipTheme.color" :text-color="chipTheme.text">
    <span style="text-transform: uppercase; letter-spacing: 2px;">{{ status }}</span>
  </v-chip>
</template>
<style scoped lang="scss"></style>
<script>
export default {
  name: 'StoreTransferStatusChip',
  props: {
    status: String,
  },
  computed: {
    chipTheme() {
      if (this.status === 'pending') return {
        text: 'white',
        color: 'grey',
      }
      if (this.status === 'out for delivery') return {
        text: 'white',
        color: 'blue',
      }
      if (this.status === 'partially delivered') return {
        text: 'orange',
        color: 'yellow',
      }
      if (this.status === 'cancelled') return {
        text: 'red darken-3',
        color: 'red',
      }
      return {
        text: 'white',
        color: 'green',
      }
    },
  },
}
/**
 * const PENDING = 'pending';
 * const APPROVED = 'approved';
 * const OUT_FOR_DELIVERY = 'out for delivery';
 * const PARTIALLY_DELIVERED = 'partially delivered';
 * const COMPLETED = 'completed';
 * const CANCELLED = 'cancelled';
 */
</script>
